import Swiper from "swiper";

const navigationSlider = document.querySelector(".js-slider-nav-init");

if (navigationSlider) initNavigationSlider(navigationSlider);

function initNavigationSlider(slider) {
    const swiperContainer = slider.querySelector(".swiper-container");

    if (!swiperContainer) return;

    const initialSlideIndex = Array.from(slider.querySelectorAll(".swiper-slide")).findIndex(
        (slide) => slide.querySelector(".active"),
    );

    new Swiper(swiperContainer, {
        slidesPerView: "auto",
        spaceBetween: 8,
        observer: true,
        observeParents: true,
        initialSlide: initialSlideIndex || 0,
    });
}
